/*
 * 全局 SOS 报警监控: 单例轮询, 任意页面发现新报警即响铃
 * 同时把最新报警数据广播给订阅者(如设备页表格)
 */
import http from "@/api/http";
import { playAlarmSound } from "./alarmSound";

const DEFAULT_INTERVAL = 10000;
let timer = null;
let knownSosIds = {};
let monitorInitialized = false;
let updateListeners = [];

// 订阅每次轮询的最新数据, 返回退订函数
export function onSosUpdate(fn) {
    updateListeners.push(fn);
    return () => {
        updateListeners = updateListeners.filter((item) => item !== fn);
    };
}

// 新报警识别: 首次只记基线不响, 之后"新出现且未处理"才响
function checkNewSosAlarm(list) {
    if (!Array.isArray(list)) {
        return;
    }
    const newUnhandled = list.filter((item) => {
        const id = item.sosId;
        if (id == null || knownSosIds[id]) {
            return false;
        }
        return !item.isHandle;
    });
    list.forEach((item) => {
        if (item.sosId != null) {
            knownSosIds[item.sosId] = true;
        }
    });
    if (!monitorInitialized) {
        monitorInitialized = true;
        return;
    }
    if (newUnhandled.length > 0) {
        playAlarmSound();
    }
}

function tick() {
    // 未登录不轮询
    if (!localStorage.getItem("mytoken")) {
        return;
    }
    http.SosList().then((res) => {
        if (!res || !res.data || res.data.code != 200) {
            return;
        }
        const data = res.data.data || {};
        checkNewSosAlarm(data.Soslist || []);
        updateListeners.forEach((fn) => fn(data));
    });
}

export function startSosMonitor(interval = DEFAULT_INTERVAL) {
    if (timer) {
        return;
    }
    tick();
    timer = setInterval(tick, interval);
}

export function stopSosMonitor() {
    if (timer) {
        clearInterval(timer);
        timer = null;
    }
}